// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir=rtl] .contentinfo[data-v-718905fa],[dir=rtl] .rowinfo[data-v-718905fa]{text-align:right}[dir=ltr] .contentinfo[data-v-718905fa],[dir=ltr] .rowinfo[data-v-718905fa]{text-align:left}", ""]);
// Exports
module.exports = exports;
